import { COLORS, marginMd, paddingSm } from 'assets/styled';
import { respondTo } from 'assets/styled/breakpoints';
import CustomSelect from 'components/Select/FormikSelect';
import styled, { css } from 'styled-components';

interface StyledProps {
  isSelected: boolean;
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-self: center;
  padding: 30rem;
  width: 100%;
  gap: 10rem;
`;

export const FormikOuter = styled.div`
  ${respondTo.smallTablet`
  width: 100%;
  max-width: 100%;
  `}
`;

export const FormWrapper = styled(Container)`
  ${respondTo.smallTablet`
  padding: 0;
  width: 100%;
  max-width: 100%;
  `}
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Title = styled.div`
  font-size: 24rem;
  font-weight: 300;
  line-height: 36rem;
  letter-spacing: 0em;
  text-align: left;
  color: ${COLORS.BLACK};
  padding-left: ${paddingSm};
  padding-right: ${paddingSm};
`;

export const Heading = styled.div`
  padding-top: 10rem;
  color: ${COLORS.BLACK};
`;

export const ApplyWrapper = styled.div`
  display: flex;
  padding-top: 10rem;
  align-items: center;
  justify-content: center;
  gap: 30rem;

  ${respondTo.smallPhone`
    flex-direction: column;
    gap: 10rem;
  `}
`;
export const ColumnContainer = styled.div`
  display: flex;
  flex-direction: column;

  ${respondTo.smallTablet`
    max-width: 100%;
    width: 100%;
  `}
`;
export const RowSpaceBetween = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 30rem;
  width: 100%;
  max-width: 100%;

  ${respondTo.smallTablet`
    flex-direction: column;
    gap: 0;
  `}
`;

export const StyledCustomSelect = styled(CustomSelect)`
  margin-top: 10rem;
  width: 100%;
  max-width: 100%;
`;

export const Row = styled.div`
  display: flex;
  margin-top: 14rem;
`;

export const FilterTypesWrapper = styled.div`
  display: flex;
  height: 30rem;
  margin-top: ${marginMd};
`;

export const FilterTypeLabel = styled.label`
  cursor: pointer;
  font-weight: 300;
  font-size: 18rem;
  line-height: 27rem;
  margin-right: ${marginMd};
  color: ${COLORS.BLACK};
  ${(props: StyledProps) =>
    props.isSelected &&
    css`
      color: ${COLORS.GREEN};
      text-decoration: underline;
      text-decoration-thickness: 2rem;
      text-decoration-position: under;
    `}
`;

export const ColumnContainerSelect = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 300rem;
  width: 100%;
  margin-bottom: 10rem;

  ${respondTo.smallTablet`
    max-width: 100%;
  `}
`;
